export function getCookie(name) {
  return (
    document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || ""
  );
}
export default (url, options) => {
  const config = useRuntimeConfig();
  let headers = {};
  if (options?.headers) {
    headers = { ...options.headers };
  }
  const csrfToken = getCookie("csrftoken");
  if (csrfToken) {
    headers["X-CSRFTOKEN"] = csrfToken;
  }
  const reqURL = new URL(url || "", config.public.baseURL);
  return $fetch(reqURL.href, {
    credentials: "include",
    ...options,
    headers,
  });
};
